// src/app/_landing/components/ProgressEarnSection.tsx
"use client";

import Image from "next/image";
import { WalletAuthButton } from "@/components/WalletAuthButton";

export const ProgressEarnSection = () => {
  return (
    <section className="w-full px-4 lg:px-8 py-16">
      <div className="max-w-6xl mx-auto">
        {/* Track Your Progress Section */}
        <div className="relative mb-16">
          {/* Green Line Background */}
          <div className="absolute inset-0 flex items-center justify-center">
            <Image
              src="https://pulsarmoney.b-cdn.net/rhuna/green_line.png"
              alt="Progress line graph background"
              width={800}
              height={120}
              className="w-full max-w-[600px] sm:max-w-[800px] h-auto object-contain opacity-30"
              priority
            />
          </div>
          
          <div className="relative z-10 text-center">
            <h2 className="text-xl lg:text-2xl font-bold text-white mb-8">
              Track Your Progress
            </h2>
            
            {/* Progress Metrics */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-3xl mx-auto">
              {/* Completed Quests */}
              <div className="text-center">
                <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-green-400 mb-1">
                  12
                </div>
                <div className="text-xs text-white">
                  Completed Quests
                </div>
              </div>
              
              {/* Leaderboard Position */}
              <div className="text-center">
                <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-green-400 mb-1">
                  #24
                </div>
                <div className="text-xs text-white">
                  Leaderboard Position
                </div>
              </div>
              
              {/* Items Crafted */}
              <div className="text-center">
                <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-green-400 mb-1">
                  8
                </div>
                <div className="text-xs text-white">
                  Items Crafted
                </div>
              </div>
              
              {/* Friends Referred */}
              <div className="text-center">
                <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-green-400 mb-1">
                  5
                </div>
                <div className="text-xs text-white">
                  Friends Referred
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Earn More Section */}
        <div className="relative flex items-center justify-center min-h-[400px] sm:min-h-[500px]">
          {/* Circular Background Image */}
          <div className="absolute inset-0 flex items-center justify-center">
            <Image
              src="https://pulsarmoney.b-cdn.net/rhuna/bottom_image.png"
              alt="Earn more background"
              width={800}
              height={800}
              className="w-full max-w-[600px] sm:max-w-[800px] h-auto object-contain opacity-80"
              priority
            />
          </div>
          
          {/* Content Overlay */}
          <div className="relative z-10 text-center px-4">
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-white mb-6 sm:mb-8 max-w-md mx-auto">
              Discover the future of events and earn rewards!
            </h2>
            
            <div className="flex justify-center">
              <WalletAuthButton variant="white" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
